import { COMPONENT_FACTORY_CONFIG_INPUT_COMPONENTS } from '@core/components/component-factory/component-factory-config-input.registry';
import type { ConfigComponentContract } from '@shared/utils/content-builder/config-component-contract';
import { computedResolvedConfig } from '@shared/utils/content-builder/block-config-computed-resolver';
import type { ShopsMapPageConfig } from '@front-platform/content-builder';
import { shopsMapPageResolveConfig } from '@front-platform/content-builder';
import { Meta } from '@angular/platform-browser';
import { Component, OnDestroy, OnInit, input } from '@angular/core';

import { HeaderService } from '@core/services/header/header.service';
export interface ShopsMapPageRuntimeConfig {
  'body'?: any;
}

export type ShopsMapPageConfigInput = Partial<
  Omit<ShopsMapPageConfig, keyof ShopsMapPageRuntimeConfig> & ShopsMapPageRuntimeConfig
>;
export type ShopsMapPageResolvedConfig = Omit<ShopsMapPageConfig, keyof ShopsMapPageRuntimeConfig> &
  Partial<ShopsMapPageRuntimeConfig>;
export interface ShopsMapPageContract extends ConfigComponentContract<
  ShopsMapPageConfigInput,
  ShopsMapPageResolvedConfig
> {}

@Component({
  selector: 'app-shops-map-page',
  templateUrl: './shops-map-page.component.html',
  standalone: false,
})
export class ShopsMapPageComponent implements OnInit, OnDestroy, ShopsMapPageContract {
  readonly config = input<ShopsMapPageConfigInput>({});
  readonly resolvedConfig = computedResolvedConfig<ShopsMapPageConfig, ShopsMapPageRuntimeConfig>(
    shopsMapPageResolveConfig,
    () => ({ config: this.config() }),
  );
  get body(): any {
    return this.resolvedConfig()['body'] as unknown as any;
  }
  get metaDescription(): string | undefined {
    return this.resolvedConfig()['meta_description'] as unknown as string | undefined;
  }

  constructor(
    private readonly meta: Meta,
    private readonly headerService: HeaderService,
  ) {}

  ngOnInit(): void {
    this.headerService.setTitle('Autour de vous');
    this.headerService.toggleShopSearchParametersVisibility(true);
    this.headerService.toggleShopSearchAddressVisibility(true);

    if (this.metaDescription) {
      this.meta.updateTag({
        name: 'description',
        content: this.metaDescription,
      });
    }
  }

  ngOnDestroy(): void {
    this.headerService.setTitle(undefined);
    this.headerService.toggleShopSearchParametersVisibility(false);
    this.headerService.toggleShopSearchAddressVisibility(false);
  }
}
COMPONENT_FACTORY_CONFIG_INPUT_COMPONENTS.set(ShopsMapPageComponent, { 'keyAliases': {} });
